const contractCommodityMapper = (resp) => {
    if (resp) {
        return resp.map((x) => {
            return {
                attId: x.attId,
                accode: x.accode,
                fileDate: x.fileDate,
                exchange: x.exchange,
                fileName: x.fileName,
                filePath: x.filePath,
                entity: x.entity,
                fileType: x.fileType,
            };
        });
    }
    return [];
};
export default contractCommodityMapper;
